<template>
  <header class="home-header">
    <!-- <CornerRibbon /> -->
    <Video videoSource="../../assets/video/flood.mp4" />
    <HeaderLogos />
    <div class="home-header__text-box">
      <div class="home-header__text">
        <h1 class="heading-primary">
          <span class="heading-primary--main"
            >FLASH FLOOD GUIDANCE SYSTEM (FFGS) SIMULATOR</span
          >
        </h1>
        <p class="home-header__paragraph">
          The Flash Flood Guidance System (FFGS) Simulator is an interactive
          application to provide learners, operational forecasters and disaster
          managers across the globe, with the realistic flash flood case
          studies. The aim is to practice the interpretation of the FFGS
          products (Diagnostic, Prognostic, Threat and Risk Products) in
          combination with weather analysis, for dissemination of timely and
          accurate flash flood warnings. The objective of the Simulator is to
          train the user in the effective usage of necessary data and products
          in order to improve flash-flood forecasting skills as well as skills
          for the actionable communication with the users of the flash-flood
          forecasts. If you would like to include additional flash flood case
          studies which occurred in one of the FFGS regions, feel free to reach
          us on ffgs@wmo.int and share the case with us. We are here to learn
          from each other and to assist in mitigation of the adverse impacts of
          one of the deadliest hazards, flash floods.
        </p>
        <Button
          buttonText="Discover regions"
          buttonSize="md"
          animated="true"
          green="true"
          @click.native="scrollIntoRegions"
        />
      </div>
    </div>
  </header>
</template>

<script>
import Button from "../UI/Button.vue";
import Video from "../UI/Video.vue";
import HeaderLogos from "../UI/HeaderLogos.vue";
// import CornerRibbon from "../UI/CornerRibbon.vue"

export default {
  components: {
    Button,
    Video,
    HeaderLogos,
    // CornerRibbon
  },
  methods: {
    scrollIntoRegions() {
      document.querySelector(".section-regions").scrollIntoView({ behavior: 'smooth' });
    },
    // uncomment when applying low internet bandwith mode
    // toggleLowInternetBandwithMode() {
    //   console.log(this.picked)
    //   this.$store.commit("updateLowInternetBandwithMode", this.picked)
    // }
  },
  // uncomment when applying low internet bandwith mode
  // computed: {
  //   gettoggleLowInternetBandwithMode() {
  //     return this.$store.getters.getLowInternetBandwithMode;
  //   }
  // }
};
</script>

<style lang="scss" scoped>
//TODO: vidit da se globalno naloadaju
@import "../../sass/_variables.scss";
@import "../../sass/_animations.scss";

.home-header {
  position: relative;
  height: 96vh;

  &__text-box {
    text-align: center;
    width: 75%;
    margin: 0 auto;
    box-shadow: 0 3rem 6rem rgba(0, 0, 0, 0.5);
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: .3rem;
    padding: 6rem;
    padding-left: 9rem;
    font-size: 1.6rem;
  }

  &__paragraph {
    font-size: $default-font-size;
    margin-bottom: 6rem;
    color: $color-grey-dark-3;
    animation: moveInRight;
    animation-duration: 1s;
    animation-timing-function: ease-out;
  }
}

.heading-primary {
  color: $color-grey-dark-3;
  text-transform: uppercase;

  /* fix-a onaj glupi move gore od 1px nakon sto animacija zavrsi */
  backface-visibility: hidden;
  margin-bottom: 6rem;

  &--main {
    display: block;
    font-size: 3.5rem;
    font-weight: 400;
    letter-spacing: 0rem;

    animation: moveInLeft;
    animation-duration: 1s;
    animation-timing-function: ease-out;
  }
}
</style>
